import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "@emotion/styled";
import { PrimaryButton, SecondaryButton } from "../../Button";
import { clearCart } from "../thunk";
import { HeadLine } from "../../HeadLine";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

const Button = styled(SecondaryButton)`
  width: 150px;
  margin-right: 1rem;
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CloseTxt = styled.p`
  line-height: 1.88;
  font-size: 14px;
`;

const ConfirmRemoveModal = ({ doClose, isOpen, doDelete }) => {
  return (
    <ReactModal
      className="Modal__Bootstrap modal-dialog"
      onRequestClose={() => {
        doClose();
      }}
      isOpen={isOpen}
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <HeadLine headingText="Attention!" />
          <div className="acct-modal-hr"></div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <CloseTxt>
            Are you sure want to remove all cards from this cart?
          </CloseTxt>
          <CloseTxt>
            Deleting this cart removes all cards from your cart completely, and
            cannot be recovered.
          </CloseTxt>
          <br />
          <div className="modal-input-mar-b-20">
            <div className="modal-input-flex-2-pad-r-10">
              <Actions>
                <PrimaryButton
                  style={{ height: "50px" }}
                  onClick={() => {
                    doDelete();
                    doClose();
                  }}
                >
                  YES
                </PrimaryButton>
                &nbsp;&nbsp;
                <SecondaryButton
                  style={{ height: "50px" }}
                  onClick={() => doClose()}
                >
                  NO
                </SecondaryButton>
              </Actions>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

ConfirmRemoveModal.propTypes = {
  doClose: PropTypes.func.isRequired,
  doDelete: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

const ClearCart = ({}) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.Cart.cart.cards);
  const [confirmRemoveOpen, setConfirmRemoveOpen] = useState(false);

  if (cards.length) {
    return (
      <>
        <Button onClick={() => setConfirmRemoveOpen(true)}>Clear Cart</Button>
        <ConfirmRemoveModal
          doClose={() => setConfirmRemoveOpen(false)}
          isOpen={confirmRemoveOpen}
          doDelete={() => dispatch(clearCart())}
        />
      </>
    );
  }

  return null;
};

export { ClearCart };
